module.exports = __webpack_public_path__ + "static/img/til27.a95e3be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til27.png
// module id = l6N8
// module chunks = 1